jQuery(document).ready(function(){
	$( ".blog-filter .filter" ).click(function() {
      var divid = $(this).data("id");
      console.log(divid);
      $('.filter').removeClass('active');
      $(this).addClass('active');
      $('.blog-listing').addClass('hidden');
      $('#'+divid).removeClass('hidden');
    });
    $(".collection-filter").change(function() {
      	if(this.checked) {
          	console.log($(this).val());
        	window.location.href = $(this).val();
      	}
  	});
	//Slick Carousel Controllers
    $(".testimonial-reel").slick({
      centerMode: true,
      centerPadding: "0px",
      dots: true,
      slidesToShow: 3,
      infinite: true,
      arrows: true,
      lazyLoad: "ondemand",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            centerMode: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  	

    $(".text-slider").slick({
      autoplay: true,
      centerMode: true,
      centerPadding: "0px",
      dots: false,
      slidesToShow: 1,
      infinite: true,
      arrows: true,
      lazyLoad: "ondemand",
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerMode: false
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
});